// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2S1Cp","modalFooterButton":"ModalNotes_modalFooterButton__1OzcK"};